import React from "react";
import "./style.scss";
import {useHistory} from "react-router";
import classNames from "classnames";
import {MODEL_CONTROL_TYPE} from "../../../utils/enums";
import Dropdown from "../Dropdown";
import { getTranslateTitle } from '../../../utils/objects-util.js';
const SectionTabs = ({model}) => {
    const history = useHistory();

    const handleOnClickTab = (tab) => {
        const newSearch = typeof tab.search === 'string' ? tab.search : tab.search()
        history.push(tab.typeModel + newSearch || '');
    }

    const handleOnFilterComboSelect = (val) => {
        history.push(val.key);
    }

    return (
        model.tabs ? (
                <div className={classNames("tabItems")}>
                    {model.tabs.map(tab => (
                        <div
                            key={`tab-${tab.title}`}
                            className={classNames("tabItem", {
                                selected: model.typeModel === tab.typeModel
                            })}
                            onClick={() => handleOnClickTab(tab)}
                        >
                            {getTranslateTitle(tab.title)}
                        </div>
                    ))}
                    {model.tabsControls && (
                        <div className={classNames("tabItemsControls")}>
                            {model.tabsControls.map(control => (
                                <div
                                    key={`control-${control.type}`}
                                    className={classNames("controlItem")}
                                >
                                    {control.type === MODEL_CONTROL_TYPE.comboUrl && (
                                        <div className={classNames("filterComboTrigger")}>
                                            <Dropdown
                                                values={control.items}
                                                value={control.value || ""}
                                                onSelect={handleOnFilterComboSelect}
                                            />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )
            : null
    )
}

export default SectionTabs;